import TeamDefaultContact from '@bb/domain/dist/types/TeamDefaultContact';
import React, { createContext, useState, useEffect } from 'react';
import { TeamDefaultContactType } from '../types';

export interface ContactModalContextProviderProps {
  visible?: boolean;
  modeType?: 'new' | 'edit';
  contact?: TeamDefaultContactType;
}

export interface ContactModalContextType
  extends ContactModalContextProviderProps {
  isSaving: boolean;
  isApplyingSettings: boolean;
  setIsSaving: React.Dispatch<React.SetStateAction<boolean>>;
  setIsApplyingSettings: React.Dispatch<React.SetStateAction<boolean>>;
  setContact: React.Dispatch<React.SetStateAction<TeamDefaultContactType>>;
  allValid: boolean;
}

const ContactModalContext: React.Context<ContactModalContextType> =
  createContext(null);

const createDefaultContact = (): TeamDefaultContactType => ({
  canConfirmAppts: true,
  canDenyAppts: true,
  canSuggestTime: true,
  importance: 'Primary',
  notifications: {
    'Action Required': false,
    Booked: true,
    Cancelled: true,
    Confirmed: true,
    Deny: true,
    'Feedback Collected': true,
    'Time Change': true,
  },
  type: 'Agent',
  contactId: undefined,
  phone: undefined,
});

export const ContactModalContextProvider: React.FC<
  ContactModalContextProviderProps
> = ({ children, visible, modeType, contact }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [isApplyingSettings, setIsApplyingSettings] = useState(false);
  const [updatedContact, setUpdatedContact] = useState(
    contact || createDefaultContact(),
  );

  useEffect(() => {
    if (visible)
      setUpdatedContact(modeType === 'new' ? createDefaultContact() : contact);
  }, [visible, modeType, contact]);

  return (
    <ContactModalContext.Provider
      value={{
        visible,
        modeType,
        contact: updatedContact,
        isSaving,
        isApplyingSettings,
        setIsSaving,
        setIsApplyingSettings,
        setContact: setUpdatedContact,
        allValid: Boolean(
          updatedContact.contactId && updatedContact.importance,
        ),
      }}
    >
      {children}
    </ContactModalContext.Provider>
  );
};

export default ContactModalContext;
